import { render, staticRenderFns } from "./TextareaAutoResize.vue?vue&type=template&id=c627c1ac&scoped=true"
import script from "./TextareaAutoResize.vue?vue&type=script&lang=js"
export * from "./TextareaAutoResize.vue?vue&type=script&lang=js"
import style0 from "./TextareaAutoResize.vue?vue&type=style&index=0&id=c627c1ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.10.0_vue-template-compiler@2.7.16_webpack@5.90.3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c627c1ac",
  null
  
)

export default component.exports